import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { BellFill, QuestionCircleFill } from "react-bootstrap-icons";
import "./Header.scss";
import { useContext } from "react";
import { UserContext } from "../../contexts/UserContext";

const getNavLinkClassName = (currentPath: string, path: string) => {
  let className = "ms-4 font-weight-600 header-link";
  if (path === currentPath) {
    className += " active-nav-link";
  }
  return className;
};

export default function Header() {
  const { t } = useTranslation();
  const location = useLocation();
  const userContext = useContext(UserContext);
  return (
    <Navbar
      bg="white"
      className="border-bottom header-component"
      collapseOnSelect
      expand="md"
    >
      <Container fluid>
        <Navbar.Brand className="ps-3" href="/">
          <img
            src={process.env.PUBLIC_URL + "/wallee-logo.svg"}
            className="d-inline-block align-top site-logo"
            alt="Wallee"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="justify-content-start flex-grow-1">
            {userContext.user?.authenticated && (
              <Nav.Link
                className={getNavLinkClassName(location.pathname, "/")}
                href="/"
              >
                {t("Applications")}
              </Nav.Link>
            )}
            <Nav.Link className="ms-4 font-weight-600 header-link d-none">
              {t("Signing Requests")}
            </Nav.Link>
          </Nav>
          <Nav className="justify-content-end flex-grow-1 pe-3">
            <Nav.Link className="ms-4 d-none">
              <BellFill className="header-icon" />
            </Nav.Link>
            <Nav.Link className="ms-4 font-weight-600 header-link d-none">
              <QuestionCircleFill className="me-2 header-icon" />
              {t("Help")}
            </Nav.Link>
            <LanguageSelector
              className="ms-4 font-weight-600 header-link"
              useNav={true}
            />
            {userContext.user?.authenticated && (
              <Nav.Link
                className="ms-4 font-weight-600 header-link "
                id="collasible-nav-dropdown"
              >
                {userContext.user?.name}
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
